// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35d93b3b","453":"fa1b89f4","455":"2899dea9","644":"2dc94a36"}[chunkId] + ".chunk.js";
};